import { useEffect } from 'react';
import { db, getCollectionName } from '../firebase';
import { doc, setDoc, serverTimestamp } from '../firestore-compat';

const HEARTBEAT_MS = 60000;

/**
 * Grava periodicamente "estou ativo agora" para o usuário logado.
 * Usado pela tela de Configurações > Online para saber quem está com o app aberto,
 * já que o last_sign_in_at do Supabase Auth só muda em login real (não em refresh de token).
 */
export function usePresenceHeartbeat(user) {
  useEffect(() => {
    if (!user || user.soInep) return; // aluno só INEP não entra na lista de "online" (o banco recusaria)
    const ref = doc(db, getCollectionName('user_presence'), user.uid);

    const beat = () => {
      setDoc(ref, {
        email: user.email,
        name: user.displayName || user.email,
        lastSeen: serverTimestamp(),
      }, { merge: true }).catch(() => {});
    };

    beat();
    const interval = setInterval(beat, HEARTBEAT_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') beat(); };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [user]);
}
